"use client";

import Link from "next/link";
import { MoveRight, Utensils } from "lucide-react";

export default function Home() {
  return (
    <div className="relative h-screen w-full flex items-center justify-center bg-slate-900 overflow-hidden font-playfair">
      {/* Dynamic Background Image with Overlay */}
      <div
        className="absolute inset-0 z-0 scale-105 animate-slow-zoom"
        style={{
          backgroundImage: `url('/default-home-bg.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.35) blur(2px)",
        }}
      />

      {/* Modern Gradient Overlays */}
      <div className="absolute inset-0 z-10 bg-gradient-to-tr from-black/60 via-transparent to-emerald-500/20" />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/40 via-transparent to-black/80" />

      {/* Main Content Card (Glassmorphism) */}
      <div className="relative z-20 max-w-4xl w-full px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm font-medium mb-8 backdrop-blur-md animate-fade-in-down">
          <Utensils className="w-4 h-4" />
          <span>Welcome to the Future of Dining</span>
        </div>

        <h1 className="text-6xl md:text-8xl font-extrabold text-white tracking-tight mb-6 animate-fade-in">
          Manage Your{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-200">
            Restaurant
          </span>{" "}
          <br className="hidden md:block" /> with Ease.
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed animate-fade-in-delayed">
          Experience the ultimate Cashless Ai dining management platform. Start
          your journey by selecting a theme that matches your brand personality.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 animate-fade-in-delayed-2">
          <Link
            href="/crm/auth/login"
            className="group relative px-10 py-5 bg-emerald-600 hover:bg-emerald-500 text-white rounded-2xl font-bold text-lg transition-all transform hover:scale-105 focus:ring-4 focus:ring-emerald-500/50 flex items-center gap-3 shadow-[0_20px_50px_rgba(16,185,129,0.3)]"
          >
            Login to Start
            <MoveRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>

          <Link
            href="https://www.thecashless.ai/"
            target="_blank"
            className="px-10 py-5 bg-white/5 hover:bg-white/10 text-white border border-white/20 rounded-2xl font-semibold text-lg backdrop-blur-md transition-all"
          >
            Explore Features
          </Link>
        </div>
      </div>

      {/* Bottom Visual Decorations */}
      <div className="absolute bottom-12 left-12 z-20 text-white/50 text-sm hidden lg:block">
        <p>
          © {new Date().getFullYear()} CashlessAI. Elevating the gastronomy
          experience.
        </p>
      </div>

      <div className="absolute bottom-12 right-12 z-20 flex gap-4 hidden lg:flex">
        <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
        <div className="w-2 h-2 rounded-full bg-emerald-500/40"></div>
        <div className="w-2 h-2 rounded-full bg-emerald-500/40"></div>
      </div>
    </div>
  );
}
